import v1 from "./v1"
// call the last version by the name of the module in order to have the last version from auto-suggestion
import OpenableText from "./v2"

export default v1; // do not break default import
export {v1};
export const v2 = OpenableText;
